import { render, staticRenderFns } from "./CladaLayout.vue?vue&type=template&id=adbed41a"
import script from "./CladaLayout.vue?vue&type=script&lang=js"
export * from "./CladaLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports